import { useMemo } from 'react'

import { getOrderCreationDto } from '../utils'
import { IOrderCreationDto } from '../api'

const useGetOrderCreationDto = (): IOrderCreationDto => {
    const orderCreationDto = useMemo(() => getOrderCreationDto(), [])

    return orderCreationDto
}

export { useGetOrderCreationDto }
